var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2"},[_c('span',_vm._b({staticClass:"text-medium text-primary font-size-1"},'span',_vm.oAtributos,false),[_vm._v(_vm._s(_vm.titulo))])])
}
var staticRenderFns = []

export { render, staticRenderFns }